
export const COSTO_LICENCIA = 650;
export const COSTO_LICENCIA_ACADEMICA = 100;
export const COSTO_MODULOS_ADICIONALES = 1000;
export const ESTATUS_BLOQUEADO = "B";
export class Compania {
    constructor(
        Id,
        Nombre,
        Codigo,
        Estatus,
        ActividadEconomica,
        NombreComercial,
        RNC,
        cierreFiscal,
        Telefonos,
        Email,
        Direcciones,
        Color1,
        ReferidoPor,
        UsaModuloVisaNet,
        UsaModuloCardNet,
        UsaModuloAzul,
        CorreoCobro,
        TelefonoCobro,
        NombreCobro,
        ApellidosCobro,
        NombreCliente,
        DocumentoCobro,
        licencias,
        licenciasCRM,
        TipoDocumentoCliente,
        DocumentoCliente,
        clienteTipo,
        UsaNomina,
        UsaFactoring,
        UsaConsulta,
        UsaWooCommerce,
        UsaShopify,
        UsaCentro,
        UsaCaja,
        UsaImpresoraFiscal,
        FacturacionElectronica,
        RazonSocial,
        UsaCardNetEnLinea,
        TipoPlanEcf,
        EsUsuarioProceso,
        EsCompaniaPrueba,
        UsaPosRestaurante,
        licenciasPT,
        UsaPrestamo
    ) {
        this.Id = Id;
        this.Nombre = Nombre;
        this.Codigo = Codigo;
        this.Estatus = Estatus;
        this.ActividadEconomica = ActividadEconomica;
        this.NombreComercial = NombreComercial;
        this.RNC = RNC;
        this.cierreFiscal = cierreFiscal;
        this.Telefonos = Telefonos;
        this.Email = Email;
        this.Color1 = Color1;
        this.ReferidoPor = ReferidoPor;
        this.UsaModuloAzul = UsaModuloAzul;
        this.UsaModuloVisaNet = UsaModuloVisaNet;
        this.UsaModuloCardNet = UsaModuloCardNet;
        this.DocumentoCobro = DocumentoCobro;
        this.NombreCliente = NombreCliente;
        this.ApellidosCobro = ApellidosCobro;
        this.NombreCobro = NombreCobro;
        this.TelefonoCobro = TelefonoCobro;
        this.CorreoCobro = CorreoCobro;
        this.licencias = licencias;
        this.licenciasCRM = licenciasCRM;
        this.DocumentoCliente =DocumentoCliente;
        this.TipoDocumentoCliente = TipoDocumentoCliente;
        this.Direcciones = Direcciones;
        this.clienteTipo = clienteTipo;
        this.UsaConsulta = UsaConsulta;
        this.UsaFactoring = UsaFactoring;
        this.UsaNomina = UsaNomina;
        this.UsaShopify = UsaShopify;
        this.UsaWooCommerce = UsaWooCommerce;
        this.UsaCaja = UsaCaja;
        this.UsaCentro = UsaCentro;
        this.UsaImpresoraFiscal = UsaImpresoraFiscal;
        this.FacturacionElectronica = FacturacionElectronica;
        this.RazonSocial = RazonSocial;
        this.UsaCardNetEnLinea = UsaCardNetEnLinea;
        this.TipoPlanEcf = TipoPlanEcf;
        this.EsUsuarioProceso = EsUsuarioProceso;
        this.EsCompaniaPrueba = EsCompaniaPrueba;
        this.UsaPosRestaurante = UsaPosRestaurante;
        this.licenciasPT = licenciasPT;
        this.UsaPrestamo = UsaPrestamo;
    }
}